"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { phCaptureException } from "@/utils/analytics";

const DISCORD_URL = "https://discord.gg/D4F25FfaGb";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
    console.error("Global error:", error);
    phCaptureException(error, {
      boundary: "global",
      digest: error.digest,
      severity: "critical",
    });
  }, [error]);

  return (
    <html lang="en" className="dark">
      <body className="bg-surface-base text-white">
        <div className="flex min-h-screen flex-col items-center justify-center px-4">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">Something went wrong</h1>
            <p className="text-zinc-400 mb-6 max-w-md">
              A critical error occurred. Please try refreshing the page or
              contact support if the problem persists.
            </p>
            {error.digest && (
              <p className="text-xs text-zinc-500 mb-4">
                Error ID: {error.digest}
              </p>
            )}
            <div className="flex gap-4 justify-center">
              <button type="button"
                onClick={reset}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Try again
              </button>
              <a
                href="/"
                className="px-4 py-2 bg-zinc-800 text-white rounded-md hover:bg-zinc-700 transition-colors"
              >
                Go home
              </a>
            </div>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 text-sm text-zinc-500 hover:text-zinc-300 transition-colors"
            >
              Report this on Discord for quick help
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
